const styles = {
  editorFont: {
    fontFamily: "consolas",
    fontSize: "16px",
  }
};

export default styles